<template>
    <div>
        <h1 class="py-3">{{ $t('managerDutyScheduleH1') }}</h1>
        <table class="table-auto w-full border border-collapse">
            <tbody>

                <!--- START Понедельник -->
                <tr class="trScheduleManager border border-bottom">
                    <td rowspan="5" class="w-1/12 tdScheduleManager">
                        <strong class="pr-3">{{ $t('monday') }}</strong>
                    </td>
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 1; theLine = 1; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[1][1]">
                            <div v-for="listDay in listWeek[1][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(1, listDay.id, 1)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 1; theLine = 1; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[1] && listResponsibleWeek[1][1]">
                            <div v-for="listDay in listResponsibleWeek[1][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 1; theLine = 2; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[1][2]">
                            <div v-for="listDay in listWeek[1][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(1, listDay.id, 2)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 1; theLine = 2; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[1] && listResponsibleWeek[1][2]">
                            <div v-for="listDay in listResponsibleWeek[1][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <!--- WhatsApp -->
                <tr class="trScheduleManager border border-end">
                    <td class="w-1/12 tdScheduleManager text-align">
                        <div>WhatsApp:</div>
                    </td>
                    <td class="vx-row">
                        <div class="vx-col" v-for="listChannel in listWhatsappWeek[1]">
                            <div class="flex p-2">
                                <div class="labelForFrsSelect">{{ listChannel.name }}</div>
                                <v-select
                                    :clearable="false"
                                    class="single-row-select frsSelect"
                                    label="full_name"
                                    :options="listManager"
                                    item-value="id"
                                    :items="listManager"
                                    v-model="listChannel['manager']"
                                    @input="updateListWhatsappWeek"
                                >      
                                    <template slot="selected-option" slot-scope="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                    <template #option="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </td>
                </tr>
                <!--- END Понедельник -->

                <!--- START Вторник -->
                <tr class="trScheduleManager border">
                    <td  rowspan="5" class="w-1/12 tdScheduleManager"><strong>{{ $t('tuesday') }}</strong>
                    </td>
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                        <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 2; theLine = 1; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[2][1]">
                            <div v-for="listDay in listWeek[2][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(2, listDay.id, 1)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 2; theLine = 1; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[2] && listResponsibleWeek[2][1]">
                            <div v-for="listDay in listResponsibleWeek[2][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                        <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 2; theLine = 2; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[2][2]">
                            <div v-for="listDay in listWeek[2][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(2, listDay.id, 2)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 2; theLine = 2; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[2] && listResponsibleWeek[2][2]">
                            <div v-for="listDay in listResponsibleWeek[2][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <!--- WhatsApp -->
                <tr class="trScheduleManager border border-end">
                    <td class="w-1/12 tdScheduleManager text-align">
                        <div>WhatsApp:</div>
                    </td>
                    <td class="vx-row">
                        <div class="vx-col" v-for="listChannel in listWhatsappWeek[2]">
                            <div class="flex p-2">
                                <div class="labelForFrsSelect">{{ listChannel.name }}</div>
                                <v-select
                                    :clearable="false"
                                    class="single-row-select frsSelect"
                                    label="full_name"
                                    :options="listManager"
                                    item-value="id"
                                    :items="listManager"
                                    v-model="listChannel['manager']"
                                    @input="updateListWhatsappWeek"
                                >      
                                    <template slot="selected-option" slot-scope="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                    <template #option="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </td>
                </tr>
                <!--- END Вторник -->

                <!--- START Среда -->
                <tr class="trScheduleManager border">
                    <td  rowspan="5" class="w-1/12 tdScheduleManager"><strong>{{ $t('wednesday') }}</strong>
                    </td>
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                        <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 3; theLine = 1; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[3][1]">
                            <div v-for="listDay in listWeek[3][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(3, listDay.id, 1)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>                
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 3; theLine = 1; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[3] && listResponsibleWeek[3][1]">
                            <div v-for="listDay in listResponsibleWeek[3][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                        <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 3; theLine = 2; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[3][2]">
                            <div v-for="listDay in listWeek[3][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(3, listDay.id, 2)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>                
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 3; theLine = 2; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[3] && listResponsibleWeek[3][2]">
                            <div v-for="listDay in listResponsibleWeek[3][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <!--- WhatsApp -->
                <tr class="trScheduleManager border border-end">
                    <td class="w-1/12 tdScheduleManager text-align">
                        <div>WhatsApp:</div>
                    </td>
                    <td class="vx-row">
                        <div class="vx-col" v-for="listChannel in listWhatsappWeek[3]">
                            <div class="flex p-2">
                                <div class="labelForFrsSelect">{{ listChannel.name }}</div>
                                <v-select
                                    :clearable="false"
                                    class="single-row-select frsSelect"
                                    label="full_name"
                                    :options="listManager"
                                    item-value="id"
                                    :items="listManager"
                                    v-model="listChannel['manager']"
                                    @input="updateListWhatsappWeek"
                                >      
                                    <template slot="selected-option" slot-scope="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                    <template #option="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </td>
                </tr>
                <!--- END Среда -->

                <!--- START Четверг -->
                <tr class="trScheduleManager border">
                    <td  rowspan="5" class="w-1/12 tdScheduleManager"><strong>{{ $t('thursday') }}</strong>
                    </td>
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                        <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 4; theLine = 1; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[4][1]">
                            <div v-for="listDay in listWeek[4][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(4, listDay.id, 1)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 4; theLine = 1; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[4] && listResponsibleWeek[4][1]">
                            <div v-for="listDay in listResponsibleWeek[4][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                        <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 4; theLine = 2; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[4][2]">
                            <div v-for="listDay in listWeek[4][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(4, listDay.id, 2)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 4; theLine = 2; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[4] && listResponsibleWeek[4][2]">
                            <div v-for="listDay in listResponsibleWeek[4][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <!--- WhatsApp -->
                <tr class="trScheduleManager border border-end">
                    <td class="w-1/12 tdScheduleManager text-align">
                        <div>WhatsApp:</div>
                    </td>
                    <td class="vx-row">
                        <div class="vx-col" v-for="listChannel in listWhatsappWeek[4]">
                            <div class="flex p-2">
                                <div class="labelForFrsSelect">{{ listChannel.name }}</div>
                                <v-select
                                    :clearable="false"
                                    class="single-row-select frsSelect"
                                    label="full_name"
                                    :options="listManager"
                                    item-value="id"
                                    :items="listManager"
                                    v-model="listChannel['manager']"
                                    @input="updateListWhatsappWeek"
                                >      
                                    <template slot="selected-option" slot-scope="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                    <template #option="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </td>
                </tr>
                <!--- END Четверг -->

                <!--- START Пятница -->
                <tr class="trScheduleManager border">
                    <td  rowspan="5" class="w-1/12 tdScheduleManager"><strong>{{ $t('friday') }}</strong>
                    </td>
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                        <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 5; theLine = 1; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[5][1]">
                            <div v-for="listDay in listWeek[5][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(5, listDay.id, 1)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 5; theLine = 1; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[5] && listResponsibleWeek[5][1]">
                            <div v-for="listDay in listResponsibleWeek[5][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                        <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 5; theLine = 2; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[5][2]">
                            <div v-for="listDay in listWeek[5][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(5, listDay.id, 2)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 5; theLine = 2; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[5] && listResponsibleWeek[5][2]">
                            <div v-for="listDay in listResponsibleWeek[5][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <!--- WhatsApp -->
                <tr class="trScheduleManager border border-end">
                    <td class="w-1/12 tdScheduleManager text-align">
                        <div>WhatsApp:</div>
                    </td>
                    <td class="vx-row">
                        <div class="vx-col" v-for="listChannel in listWhatsappWeek[5]">
                            <div class="flex p-2">
                                <div class="labelForFrsSelect">{{ listChannel.name }}</div>
                                <v-select
                                    :clearable="false"
                                    class="single-row-select frsSelect"
                                    label="full_name"
                                    :options="listManager"
                                    item-value="id"
                                    :items="listManager"
                                    v-model="listChannel['manager']"
                                    @input="updateListWhatsappWeek"
                                >      
                                    <template slot="selected-option" slot-scope="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                    <template #option="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </td>
                </tr>
                <!--- END Пятница -->

                <!--- START Суббота -->
                <tr class="trScheduleManager border">
                    <td  rowspan="5" class="w-1/12 tdScheduleManager"><strong>{{ $t('saturday') }}</strong>
                    </td>
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                        <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 6; theLine = 1; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[6][1]">
                            <div v-for="listDay in listWeek[6][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(6, listDay.id, 1)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 6; theLine = 1; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[6] && listResponsibleWeek[6][1]">
                            <div v-for="listDay in listResponsibleWeek[6][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                        <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 6; theLine = 2; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[6][2]">
                            <div v-for="listDay in listWeek[6][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(6, listDay.id, 2)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 6; theLine = 2; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[6] && listResponsibleWeek[6][2]">
                            <div v-for="listDay in listResponsibleWeek[6][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <!--- WhatsApp -->
                <tr class="trScheduleManager border border-end">
                    <td class="w-1/12 tdScheduleManager text-align">
                        <div>WhatsApp:</div>
                    </td>
                    <td class="vx-row">
                        <div class="vx-col" v-for="listChannel in listWhatsappWeek[6]">
                            <div class="flex p-2">
                                <div class="labelForFrsSelect">{{ listChannel.name }}</div>
                                <v-select
                                    :clearable="false"
                                    class="single-row-select frsSelect"
                                    label="full_name"
                                    :options="listManager"
                                    item-value="id"
                                    :items="listManager"
                                    v-model="listChannel['manager']"
                                    @input="updateListWhatsappWeek"
                                >      
                                    <template slot="selected-option" slot-scope="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                    <template #option="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </td>
                </tr>
                <!--- END Суббота -->

                <!--- START Воскресение -->
                <tr class="trScheduleManager border">
                    <td  rowspan="5" class="w-1/12 tdScheduleManager"><strong>{{ $t('sunday') }}</strong>
                    </td>
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                        <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 7; theLine = 1; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[7][1]">
                            <div v-for="listDay in listWeek[7][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(7, listDay.id, 1)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameFirstLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 7; theLine = 1; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[7] && listResponsibleWeek[7][1]">
                            <div v-for="listDay in listResponsibleWeek[7][1]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                        <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 7; theLine = 2; managerPopupActive = true"
                        >
                            {{ $t('add') }}
                        </vs-button>
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listWeek[7][2]">
                            <div v-for="listDay in listWeek[7][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                            <span class="text-sm">
                                                <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                                <strong>{{ listDay.count_active_order }}</strong>
                                            </span>
                                        </div>
                                        <feather-icon
                                            icon="XIcon"
                                            class="text-danger ml-2 cursor-pointer"
                                            @click="deleteManager(7, listDay.id, 2)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr class="trScheduleManager border border-bottom">
                    <td class="w-1/12 tdScheduleManager text-center">
                        {{ $t('managerDutyScheduleNameSecondLine') }}
                       <vs-button
                            class="px-3 py-2 text-sm font-medium text-center"
                            color="primary"
                            @click="theDay = 7; theLine = 2; managerResponsiblePopupActive = true"
                        >
                            {{ $t('select') }}
                        </vs-button>
                        {{ $t('responsible') }}
                    </td>
                    <td  class="vx-row order__head-col_inner">
                        <template v-if="listResponsibleWeek && listResponsibleWeek[7] && listResponsibleWeek[7][2]">
                            <div v-for="listDay in listResponsibleWeek[7][2]" class="order-author vx-col order__head-col">
                                <div class="order-author__container">
                                    <div class="order-author__block">
                                        <div class="order-author__link">
                                            <div class="order-author__photo">
                                                <img v-if="listDay.photo" :src="listDay.photo"/>
                                            </div>
                                            <div class="order-author__name">
                                                {{ listDay.full_name }}&nbsp; 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
                 <!--- WhatsApp -->
                 <tr class="trScheduleManager border border-end">
                    <td class="w-1/12 tdScheduleManager text-align">
                        <div>WhatsApp:</div>
                    </td>
                    <td class="vx-row">
                        <div class="vx-col" v-for="listChannel in listWhatsappWeek[7]">
                            <div class="flex p-2">
                                <div class="labelForFrsSelect">{{ listChannel.name }}</div>
                                <v-select
                                    :clearable="false"
                                    class="single-row-select frsSelect"
                                    label="full_name"
                                    :options="listManager"
                                    item-value="id"
                                    :items="listManager"
                                    v-model="listChannel['manager']"
                                    @input="updateListWhatsappWeek"
                                >      
                                    <template slot="selected-option" slot-scope="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                    <template #option="option">
                                        <span class="frsSelectSpanManager">
                                            <img :src="option.photo" />
                                            {{ option.full_name }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </td>
                </tr>
                <!--- END Воскресение -->
            </tbody>
        </table>
		<div class="site-edit-item__controls vx-row mt-3 flex justify-end">
			<div class="vx-col mt-2">
				<RouterLink to="/managers">
					<vs-button color="primary" type="filled">{{ $t('goBack') }}</vs-button>
				</RouterLink>
			</div>
		</div>
        <ChangeManagerForDutySchedule
			:active.sync="managerPopupActive"
            :theDay = "theDay"
            :theLine = "theLine"
            @confirm = "confirmSelectedManagers"
		/>
        <ChangeResponsibleManagerForDutySchedule
			:active.sync="managerResponsiblePopupActive"
            :theDay = "theDay"
            :theLine = "theLine"
            @confirm = "confirmSelectedResponsibleManager"
		/>
    </div>
</template>

<script>
    import databaseManager from "@/mixins/databaseManager";
    import notifier from "@/mixins/notifier";
    import vSelect from "vue-select";
    import ChangeManagerForDutySchedule from "@/components/dialogs/ChangeManagerForDutySchedule";
    import ChangeResponsibleManagerForDutySchedule from "@/components/dialogs/ChangeResponsibleManagerForDutySchedule";

    export default {
        name: "DutySchedule",
        mixins: [databaseManager, notifier],
        components: {
            vSelect,
            ChangeManagerForDutySchedule,
            ChangeResponsibleManagerForDutySchedule,
        },
        data() {
            return {
                listManager: [],
                listWeek: [],
                listResponsibleWeek: [],
                listWhatsappWeek: [],
                manager: "",
                managerPopupActive: false,
                managerResponsiblePopupActive: false,
                theDay: "",
                theLine: "",
            }
        },
        methods: {
            async updateListWhatsappWeek() {
                try {
                    await this.dbUpdateListWhatsappWeek(this.listWhatsappWeek);
                    this.notifySuccess(this.$t("changesIsSavedSuccessfully"));
                } catch (e) {
                    this.notifyError(this.$t('errorNotification'));
                }
            },
            async getListManager(manager) {
                this.listManager = await this.dbGetListMangers();
            },
            getSelectedManager() {
                return this.listManager[10];
            },
            async confirmSelectedResponsibleManager(selectedResponsibleManager, selectedManagers) {
                try{
                    await this.dbAddDutyResponsibleManagers(this.theDay, this.theLine, selectedResponsibleManager, selectedManagers);
                    this.notifySuccess(`${this.$t('dataIsSaved')}`);
                    await this.getDutyScheduleListResponsibleWeek();
                }catch (e) {
                    this.notifyError(e.message);
                }            
            },
            async confirmSelectedManagers(arr) {
                try{
                    await this.dbAddDutyManagers(arr, this.theDay, this.theLine);
                    this.notifySuccess(`${this.$t('dataIsSaved')}`);
                    await this.getDutyScheduleListWeek();
                }catch (e) {
                    this.notifyError(e.message);
                }
            },
            async getDutyScheduleListWeek() {
                this.listWeek = await this.dbGetDutyScheduleListWeek();
            },
            async getDutyScheduleListResponsibleWeek() {
                this.listResponsibleWeek = await this.dbGetDutyScheduleListResponsibleWeek();
            },
            async getDutyWhatsappListWeek() {
                this.listWhatsappWeek = await this.dbGetDutyWhatsappListWeek();
            },
            makeManagerDeletion: async function(parameters) {
                try {
                    await this.dbDeleteManagerFromDutyDay(parameters[0], parameters[1], parameters[2]);
                    this.notifySuccess(this.$t("deletedSuccessfully"));
                    await this.getDutyScheduleListWeek();
                } catch (e) {
                    this.notifyError(this.$t('errorNotification'));
                }
            },
            deleteManager(day, managerId, line) {
                this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: this.$t('confirmDeletion'),
                    text: this.$t('doYouWantToDeleteManagerFromDay'),
                    // accept: this.makeManagerDeletion(day, managerId),
                    accept: this.makeManagerDeletion,
                    parameters: [day, managerId, line],
                    acceptText: this.$t('confirm'),
                    cancelText: this.$t('cancel')
                });
            },
        },
        async created() {
            const role = this.$store.state.auth.role;

            this.getDutyScheduleListWeek();
            this.getDutyScheduleListResponsibleWeek();
            this.getDutyWhatsappListWeek();

            if(role === 'admin') await this.getListManager();
        }
    };
</script>

<style lang="scss">
    @import "./src/assets/scss/vuexy/functions";
    @import "./src/assets/scss/vuexy/variables";

    .labelForFrsSelect {
        font-weight: bolder;
        font-size: smaller;
        margin-right: 5px;
        padding: 10px;
    }

    .frsSelect {
		min-width: 280px;
		font-size: small;
		line-height: 20px;
		margin: auto;
	}
	.frsSelectSpanManager {
		display: flex;
		line-height: 20px;
		font-size: small;
		color: black;
	
		img {
			width: 30px;
			height: 30px;
			margin-right: 10px;
		}	

	}
	.frsSelectSpanColorManager {
		display: flex;
		line-height: 20px;
		font-size: small;
	}

    .order {
        &__head {
            @media screen and (max-width: 580px){
                justify-content: center !important;
            }
        }

        &__head-col {
            @media screen and (max-width: 768px) {
                justify-content: center;
                flex: 100%;

                &_inner {
                    justify-content: center;
                    flex: 100%;
                    margin-top: -10px;

                    & > .vx-col {
                        margin-top: 10px;
                    }
                }
            }
        }
        &-author {
            display: flex;

            &__container {
                display: flex;
            }

            &__title {
                display: flex;
                align-items: center;
                font-size: 18px;
                font-weight: 600;
            }

            &__block {
                position: relative;
                display: flex;
                align-items: center;
                border-radius: 1000px;
                background-color: #F8F8F8;
                height: 35px;
                border: rgba(136, 136, 136, 0.5) 1px solid;
                padding: 0 12px 0 0 !important;
                margin-left: 10px;
            }

            &__link {
                display: flex;
                align-items: center;
                height: 100%;
            }

            &__photo {
                position: absolute;
                left: -1px;
                border-radius: 100%;
                width: 35px;
                height: 35px;
                overflow: hidden;
                background-color: $primary;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 100%;
                }
            }

            &__name {
                margin-left: 45px;
                color: #3D3D3D;
                font-weight: 600;
                white-space: nowrap;
            }
        }
        &__head {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-top: -8px;
            margin-bottom: -8px;

            @media (max-width: 768px) {
                margin-top: -4px;
                margin-bottom: -4px;

                &-col {
                    margin-top: 0px;
                    margin-bottom: 4px;
                }
            }

            b {
                margin-right: 10px;
            }

            &-status,
            &-order {
                align-items: center;
                display: flex;
            }

            &-info {
                display: flex;
                align-items: center;
            }

            &-col {
                margin-top: 8px;
                margin-bottom: 8px;
            }
        }
    }

    .trScheduleManager {
        border: 2px solid;
    }
    .border-start {
        border-bottom: 0px solid !important;
        border-bottom-width: 0px !important;
    }
    .border-end {
        border-top: 0px solid !important;
        border-top-width: 0px !important;
    }
    .tdScheduleManager {
        padding: 5px;
    }

    .align-center {
	    align-items: center;
    }
    .mini-img {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 100%;
    }
</style>